var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.80005 4.66536H9.13338V5.9987H7.80005V4.66536ZM7.80005 7.33203H9.13338V11.332H7.80005V7.33203ZM8.46672 1.33203C4.78672 1.33203 1.80005 4.3187 1.80005 7.9987C1.80005 11.6787 4.78672 14.6654 8.46672 14.6654C12.1467 14.6654 15.1334 11.6787 15.1334 7.9987C15.1334 4.3187 12.1467 1.33203 8.46672 1.33203ZM8.46672 13.332C5.52672 13.332 3.13338 10.9387 3.13338 7.9987C3.13338 5.0587 5.52672 2.66536 8.46672 2.66536C11.4067 2.66536 13.8 5.0587 13.8 7.9987C13.8 10.9387 11.4067 13.332 8.46672 13.332Z",
    fill: "#0054B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOutlined);
export default __webpack_public_path__ + "static/media/info-outlined.76cb8f62e0aa117526814ef2cdc7d88c.svg";
export { ForwardRef as ReactComponent };